import React from 'react';
import Paper from 'material-ui/Paper';
import { Tabs, Tab } from 'material-ui/Tabs';

import Overall from './Overall';

import { in_array } from '../utils';

export default class MainInterface extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      role: props.role
    }
  }

  render() {
    return (
      <div>
        {this.state.role === 'none' &&
          <p>An error occured. Please clear the browser cache & cookies and reload this page.</p>
        }
        <Tabs>
          {in_array(this.state.role, ['user', 'manager', 'analyst', 'admin']) &&
            <Tab label="System Status">
              <Paper className="paper-page-container">
                <Overall/>
              </Paper>
            </Tab>
          }
          {in_array(this.state.role, ['analyst', 'admin']) &&
            <Tab label="Analysis">
              <Paper className="paper-page-container">
                <h2>Under Construction</h2>
                {/* <TimeInfo/> */}
              </Paper>
            </Tab>
          }
          {in_array(this.state.role, ['manager', 'admin']) &&
            <Tab label="Administration">
              <Paper className="paper-page-container">
                <h2>Under Construction</h2>
                {/* <AdminPanel/> */}
              </Paper>
            </Tab>
          }
        </Tabs>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/MainInterface.js